import { i18nMark } from 'lingui-react';

const messages = {
  title: i18nMark('Add Note'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/AddNoteButton/messages.js